import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography } from "@avenue-8/sidekick-ui";
import { RootLayout } from "@shared/layouts/RootLayout";
import { PageContainer } from "./styles";
import { appConfig } from "@shared/utils/appConfig";

// Used in dev mode only
const APP_CALLBACK_URL = "sidekick://sso/callback";
const isDev = appConfig.APP_ENV === "development";

export const SsoCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  useEffect(() => {
    /*
     * Custom URL schemes are not origin-bound and can be intercepted by other
     * apps claiming the same scheme. Only use this fallback in development where
     * Universal Links are not available. In production, Universal Links handle
     * the redirect at the OS level before the browser ever opens this page.
     */
    if (!code || !isDev) return;
    window.location.href = `${APP_CALLBACK_URL}?code=${encodeURIComponent(code)}`;
  }, [code]);

  return (
    <RootLayout theme="light">
      <PageContainer>
        {!code ? (
          <Box alignItems="center" gap={2}>
            <Typography variant="h6">Invalid login link.</Typography>
            <Typography variant="body2" textAlign="center">
              Go back to the Sidekick app and sign in again.
            </Typography>
          </Box>
        ) : (
          <Box alignItems="center" gap={2}>
            <Typography variant="h6">Return to the Sidekick app.</Typography>
            <Typography variant="body2" textAlign="center">
              Sign-in is complete. Open the Sidekick app to continue.
            </Typography>
          </Box>
        )}
      </PageContainer>
    </RootLayout>
  );
};
